// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Button_button__JBBzO {
  display: flex;
  flex-shrink: 0;
  cursor: pointer;
  align-items: center;
  justify-content: center;
  gap: 0.25rem;
  white-space: nowrap;
  border-radius: 0.375rem;
  border-width: 1px;
  --tw-border-opacity: 1;
  border-color: rgb(208 213 221 / var(--tw-border-opacity));
  padding-top: 0.625rem;
  padding-bottom: 0.625rem;
  padding-left: 0.875rem;
  padding-right: 0.875rem;
  font-family: Inter, sans-serif;
  font-size: 0.875rem;
  font-weight: 600;
  line-height: 1.25rem;
  letter-spacing: 0%;
  --tw-text-opacity: 1;
  color: rgb(52 64 84 / var(--tw-text-opacity));
  transition-property: all;
  transition-timing-function: cubic-bezier(0.4, 0, 0.2, 1);
  transition-duration: 150ms;
}

/* Default Variants */
.Button_primary__9MLUH {
  --tw-border-opacity: 1;
  border-color: rgb(44 63 126 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(44 63 126 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}
.Button_primary__9MLUH:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(30 45 94 / var(--tw-bg-opacity));
}

.Button_secondary__sUGsj {
  --tw-border-opacity: 1;
  border-color: rgb(208 213 221 / var(--tw-border-opacity));
  --tw-bg-opacity: 1;
  background-color: rgb(240 240 240 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(0 0 0 / var(--tw-text-opacity));
}

.Button_secondary__sUGsj:hover {
  --tw-bg-opacity: 1;
  background-color: rgb(12 102 228 / var(--tw-bg-opacity));
  --tw-text-opacity: 1;
  color: rgb(255 255 255 / var(--tw-text-opacity));
}

.Button_disabled__DkgJ\\+ {
  opacity: 0.6;
  cursor: not-allowed;
}`, "",{"version":3,"sources":["webpack://./src/components/Button/Button.module.scss"],"names":[],"mappings":"AACI;EAAA,aAAA;EAAA,cAAA;EAAA,eAAA;EAAA,mBAAA;EAAA,uBAAA;EAAA,YAAA;EAAA,mBAAA;EAAA,uBAAA;EAAA,iBAAA;EAAA,sBAAA;EAAA,yDAAA;EAAA,qBAAA;EAAA,wBAAA;EAAA,sBAAA;EAAA,uBAAA;EAAA,8BAAA;EAAA,mBAAA;EAAA,gBAAA;EAAA,oBAAA;EAAA,kBAAA;EAAA,oBAAA;EAAA,6CAAA;EAAA,wBAAA;EAAA,wDAAA;EAAA;AAAA;;AAMF,qBAAA;AAEE;EAAA,sBAAA;EAAA,uDAAA;EAAA,kBAAA;EAAA,uDAAA;EAAA,oBAAA;EAAA;AAAA;AAAA;EAAA,kBAAA;EAAA;AAAA;;AAGA;EAAA,sBAAA;EAAA,yDAAA;EAAA,kBAAA;EAAA,yDAAA;EAAA,oBAAA;EAAA;AAAA;;AAAA;EAAA,kBAAA;EAAA,wDAAA;EAAA,oBAAA;EAAA;AAAA;;AAGJ;EACE,YAAA;EACA,mBAAA;AAEF","sourcesContent":[".button {\n    @apply font-inter font-semibold text-sm leading-5 tracking-[0%]\n           text-[#344054] flex items-center justify-center py-2.5 px-3.5\n           border border-[#D0D5DD] rounded-md gap-1 cursor-pointer transition-all\n           whitespace-nowrap shrink-0;\n  }\n  \n  /* Default Variants */\n  .primary {\n    @apply bg-[#2C3F7E] text-white border-[#2C3F7E] hover:bg-[#1E2D5E];\n  }\n  .secondary {\n    @apply bg-[#F0F0F0] text-black border-[#D0D5DD] hover:bg-[#0C66E4] hover:text-white;\n  }\n  \n.disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n  \n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"button": `Button_button__JBBzO`,
	"primary": `Button_primary__9MLUH`,
	"secondary": `Button_secondary__sUGsj`,
	"disabled": `Button_disabled__DkgJ+`
};
export default ___CSS_LOADER_EXPORT___;
